import request from '@/axios'

// 获取未读消息数量
export const getUnreadNoticeCountApi = () => {
  return request.get({ url: '/system/noticeRead/unread' })
}

// 获取消息列表
export const getNoticeListApi = (params: any) => {
  return request.get({ url: '/system/noticeRead/allList', params })
}

// 获取消息详情
export const getNoticeDetailApi = (noticeId: number) => {
  return request.get({ url: `/system/noticeRead/notice/${noticeId}` })
}

// 获取已读消息列表
export const getReadNoticeListApi = () => {
  return request.get({ url: '/system/noticeRead/read' })
}
